import isCountryWithBanner from 'components/betting-warning-banner/utils/is-country-with-banner';
import { SessionTimerIframe } from 'components/ExpandedNavbar/partials/session-timer-iframe';
import HomepageLink from 'components/HomepageLink/HomepageLink.component';
import MenuTabs from 'components/MenuTabs/MenuTabs.component';
import React from 'react';
import { ExpandedNavbarProps } from './ExpandedNavbar.type';
import SecondaryLinks from './partials/SecondaryLinks.component';
import {
  InnerContainer,
  NavbarWrapper,
  WithBannerNavbarWrapper,
} from './style/ExpandedNavbar.style';
const ExpandedNavbar: React.FC<ExpandedNavbarProps> = function ExpandedNavbar({
  children,
  navbarContent,
}) {
  const NavbarWrapperComponent = isCountryWithBanner()
    ? WithBannerNavbarWrapper
    : NavbarWrapper;

  return (
    <NavbarWrapperComponent>
      <SessionTimerIframe />
      <InnerContainer>
        <HomepageLink href={navbarContent.logoLink} />
        <MenuTabs
          menuTabList={navbarContent.menuTab}
          domIdPrefix={'expanded-navbar'}
        />
        <SecondaryLinks navbarContent={navbarContent} />
        {children}
      </InnerContainer>
    </NavbarWrapperComponent>
  );
};

export default ExpandedNavbar;
